










































import { Prop, Component, Vue } from "vue-property-decorator";
import {
  getAddressFromPostcode,
  getLatitudeAndLongitudeFromAddress
} from "@/api/location-api";

interface Location {
  postcode: string;
  address: string;
  latitude: number;
  longitude: number;
}

function newLocation(): Location {
  return {
    postcode: "",
    address: "",
    latitude: 0,
    longitude: 0
  };
}

@Component({
  props: {
    required: {
      type: Boolean,
      default: false
    }
  }
})
export default class VLocationControl extends Vue {
  @Prop({ default: newLocation }) location!: Location;
  @Prop({ default: "postcode" }) postcodeName!: string;
  @Prop({ default: "address" }) addressName!: string;
  @Prop({ default: "latitude" }) latitudeName!: string;
  @Prop({ default: "longitude" }) longitudeName!: string;

  hasErrorGetAddress = false;
  hasErrorGetLatitude = false;

  async setAddress() {
    const code = this.location.postcode.replace(/[^0-9]/g, ""); // 数字だけ取り出す
    const address = await getAddressFromPostcode(code);
    this.location.address = address;
    this.hasErrorGetAddress = !address;
    await this.updateLatitudeAndLongitude();
    (this.$refs.address as any).focus();
  }

  async updateLatitudeAndLongitude() {
    if (!this.location.address) return;
    // 検索中にsubmitされるのを抑える
    (this.$refs.address as HTMLInputElement).setCustomValidity(
      "緯度経度を検索中です。少々お待ちください。"
    );
    const { latitude, longitude } = await getLatitudeAndLongitudeFromAddress(
      this.location.address
    );
    if (latitude && longitude) {
      this.location.latitude = latitude;
      this.location.longitude = longitude;
      this.hasErrorGetLatitude = false;
    } else {
      this.hasErrorGetLatitude = true;
    }
    (this.$refs.address as HTMLInputElement).setCustomValidity("");
  }
}
